"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _Constants = require("FileManagerLib/Constants");

var _InfiniteTiles = _interopRequireDefault(require("FileManagerLib/components/browser/InfiniteTiles"));

var _Thumbnail = _interopRequireDefault(require("FileManagerLib/components/browser/Thumbnail"));

var _Folder = _interopRequireDefault(require("FileManagerLib/components/browser/Folder"));

var _File = _interopRequireDefault(require("FileManagerLib/components/browser/File"));

var _FileDetailContainer = _interopRequireDefault(require("FileManagerLib/containers/browser/FileDetailContainer"));

var noop = function noop() {
  return undefined;
};

var FoldersAndFiles =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FoldersAndFiles, _Component);

  function FoldersAndFiles(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FoldersAndFiles);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FoldersAndFiles).call(this, props));
    _this.renderTile = _this.renderTile.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderThumbnail = _this.renderThumbnail.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderFolder = _this.renderFolder.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderFile = _this.renderFile.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderFileDetail = _this.renderFileDetail.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDrop = _this.handleDrop.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCloseFileDetail = _this.handleCloseFileDetail.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleFileInsert = _this.handleFileInsert.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FoldersAndFiles, [{
    key: "getRenderer",
    value: function getRenderer(tile) {
      switch (tile.get('type')) {
        case _Constants.CellTypes.FILE:
          return this.renderFile;

        case _Constants.CellTypes.FOLDER:
          return this.renderFolder;

        case _Constants.CellTypes.THUMBNAIL:
          return this.renderThumbnail;

        case _Constants.CellTypes.FILE_DETAIL:
          return this.renderFileDetail;

        default:
          return noop;
      }
    }
  }, {
    key: "handleCloseFileDetail",
    value: function handleCloseFileDetail() {
      var usageTrackingMeta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var onSelectFile = this.props.onSelectFile;
      onSelectFile(null, usageTrackingMeta);
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(files, folder) {
      var _this$props = this.props,
          type = _this$props.type,
          onDropFiles = _this$props.onDropFiles;
      onDropFiles(files, folder, type);
    }
  }, {
    key: "handleFileInsert",
    value: function handleFileInsert(file) {
      var onInsert = this.props.onInsert;
      onInsert(file);
    }
  }, {
    key: "renderFileDetail",
    value: function renderFileDetail(tile) {
      return _react.default.createElement(_FileDetailContainer.default, {
        tile: tile,
        onInsert: this.handleFileInsert,
        onClose: this.handleCloseFileDetail
      });
    }
  }, {
    key: "renderThumbnail",
    value: function renderThumbnail(tile) {
      var image = tile.get('image');
      var _this$props2 = this.props,
          onSelectFile = _this$props2.onSelectFile,
          onInsert = _this$props2.onInsert,
          selectedFile = _this$props2.selectedFile;
      return _react.default.createElement(_Thumbnail.default, {
        selectedFile: selectedFile,
        image: image,
        width: 120,
        onSelect: onSelectFile,
        onInsert: onInsert
      });
    }
  }, {
    key: "renderFolder",
    value: function renderFolder(tile) {
      var folder = tile.get('folder');
      var onSelectFolder = this.props.onSelectFolder;
      return _react.default.createElement(_Folder.default, {
        folder: folder,
        last: tile.get('isLast'),
        onSelect: onSelectFolder,
        onDropFiles: this.handleDrop
      });
    }
  }, {
    key: "renderFile",
    value: function renderFile(tile) {
      var _this$props3 = this.props,
          onSelectFile = _this$props3.onSelectFile,
          onInsert = _this$props3.onInsert,
          selectedFile = _this$props3.selectedFile,
          uploadingFiles = _this$props3.uploadingFiles;
      var file = tile.get('file');
      var fileId = file.get('id');
      var isFileUploading = uploadingFiles.has(fileId);
      return _react.default.createElement(_File.default, {
        file: file,
        selected: !!(selectedFile && fileId === selectedFile.get('id')),
        last: tile.get('isLast'),
        onSelect: onSelectFile,
        onInsert: onInsert,
        isUploading: isFileUploading,
        uploadProgress: isFileUploading ? uploadingFiles.getIn([fileId, 'progress']) : undefined
      });
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      var renderer = this.getRenderer(tile);
      return renderer(tile);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          tiles = _this$props4.tiles,
          total = _this$props4.total,
          onLoadMoreFiles = _this$props4.onLoadMoreFiles;
      return _react.default.createElement(_InfiniteTiles.default, {
        onLoadMoreImages: onLoadMoreFiles,
        tileRenderer: this.renderTile,
        tiles: tiles,
        total: total
      });
    }
  }]);
  return FoldersAndFiles;
}(_react.Component);

FoldersAndFiles.propTypes = {
  type: _react.PropTypes.oneOf(Object.keys(_Constants.DrawerTypes)).isRequired,
  tiles: _react.PropTypes.instanceOf(_immutable.default.List),
  selectedFile: _react.PropTypes.instanceOf(_immutable.default.Map),
  total: _react.PropTypes.number.isRequired,
  onDropFiles: _react.PropTypes.func.isRequired,
  onInsert: _react.PropTypes.func.isRequired,
  onLoadMoreFiles: _react.PropTypes.func.isRequired,
  onSelectFile: _react.PropTypes.func.isRequired,
  onSelectFolder: _react.PropTypes.func.isRequired,
  uploadingFiles: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired
};
var _default = FoldersAndFiles;
exports.default = _default;
module.exports = exports.default;